(function () {
  const initSlider = (section) => {
    if (!section || !section.classList.contains("social-media-section")) {
      return;
    }

    const slider = section.querySelector(".social-media-slider");

    if (!slider) return;

    const defaultSpeed = 15000;

    const speed = Number(slider.dataset.speed ?? defaultSpeed);

    const slidesPerViewDesktop = Number(
      slider.dataset.slidesPerViewDesktop
    );

    const slidesPerViewMobile = Number(
      slider.dataset.slidesPerViewMobile
    );

    const stopAutoplaySlider = slider.dataset.stopOnHover === "true";

    const hasAutoplay = slider.dataset.autoplay === "true";

    const mediaSwiper = new Swiper(slider, {
      loop: true,
      allowTouchMove: hasAutoplay ? false : true,
      speed: hasAutoplay ? speed : 500,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 20,
      autoplay: hasAutoplay
        ? {
            delay: 0,
            disableOnInteraction: false,
          }
        : false,

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        576: {
          slidesPerView: slidesPerViewDesktop,
        },
      },
    });

    // Pause autoplay on hover ONLY when autoplay is enabled
    if (stopAutoplaySlider && hasAutoplay) {
      let duration;
      let distanceRatio;
      let startTimer;

      const stopAutoplay = () => {
        if (startTimer) clearTimeout(startTimer);

        mediaSwiper.setTranslate(mediaSwiper.getTranslate());

        const currentSlideWidth =
          mediaSwiper.slides[mediaSwiper.activeIndex].offsetWidth;

        distanceRatio = Math.abs(
          (currentSlideWidth * mediaSwiper.activeIndex +
            mediaSwiper.getTranslate()) /
            currentSlideWidth
        );

        duration = mediaSwiper.params.speed * distanceRatio;

        mediaSwiper.autoplay.stop();
      };

      const startAutoplay = (delay = duration || 0) => {
        startTimer = setTimeout(() => {
          mediaSwiper.autoplay.start();
        }, delay);
      };

      slider.addEventListener("mouseenter", stopAutoplay);

      slider.addEventListener("mouseleave", () => {
        const distance =
          mediaSwiper.width * mediaSwiper.activeIndex +
          mediaSwiper.getTranslate();

        duration = distance !== 0 ? duration : 0;

        mediaSwiper.slideTo(mediaSwiper.activeIndex, duration);

        startAutoplay();
      });
    }
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();




